// utils/toastErrors.js
import { toast } from "react-toastify";

const FIELD_TRANSLATIONS = {
  nom: "Nom",
  prenom: "Prénom",
  email: "E-mail",
  produit: "Produit",
  produits_associes: "Produits associés",
  quantite: "Quantité",
  prix: "Prix",
  dossier: "Dossier",
  intitule: "Intitulé",
  client: "Client",
  fournisseur: "Fournisseur",
  compte_comptable: "Compte comptable",
};

function formatErrorDetail(key, val) {
  // Ignorer les clés génériques d'erreur
  const displayKey = (key === "non_field_errors" || key === "message" || key === "detail" || key === "status") ? "" : (FIELD_TRANSLATIONS[key] || key);
  
  if (typeof val === "string") {
    return displayKey ? `${displayKey} : ${val}` : val;
  }
  
  if (Array.isArray(val)) {
    return val.map(item => formatErrorDetail(key, item)).filter(Boolean).join("\n");
  }
  
  if (typeof val === "object" && val !== null) {
    return Object.entries(val)
      .map(([subKey, subVal]) => {
        const nextKey = isNaN(subKey) ? subKey : key;
        return formatErrorDetail(nextKey, subVal);
      })
      .filter(Boolean)
      .join("\n");
  }
  
  return "";
}

export function toastApiErrors(error) {
  const message = error?.data?.message || error?.message || error?.data?.detail || error?.detail;

  if (!message) {
    toast.error("Une erreur inattendue s'est produite.");
    return;
  }

  const formattedError = formatErrorDetail("message", message);
  if (formattedError) {
    formattedError.split("\n").forEach(err => {
      if (err.trim()) {
        toast.error(err.trim());
      }
    });
  } else {
    toast.error("Une erreur inattendue s'est produite.");
  }
}